var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.label
    ? _c(
        "v-chip",
        { attrs: { "x-small": "", outlined: "", color: "success" } },
        [
          _c("v-progress-circular", {
            staticClass: "mr-1",
            attrs: { indeterminate: "", size: "10", width: "2" },
          }),
          _vm._v(" " + _vm._s(_vm.label) + " "),
        ],
        1
      )
    : _vm.failed
    ? _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-chip",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            "x-small": "",
                            outlined: "",
                            color: "error",
                          },
                        },
                        "v-chip",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { "x-small": "" } },
                        [_vm._v("mdi-alert-circle-outline")]
                      ),
                      _vm._v(" Falha ao atualizar "),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.errorCode || "Erro desconhecido"))])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }